import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { ButtonStyled } from './storelocator-link.styled'
import { object, string } from 'prop-types'
import { cx } from '@emotion/css'

const StorelocatorLink = ({ className, buttonProps }) => {
	const { storelocator: { path, enabled } = {} } = useConfig()
	return (
		<>{enabled && <ButtonStyled className={cx('StorelocatorLink-root', className)} {...buttonProps} href={path} />}</>
	)
}

StorelocatorLink.propTypes = {
	/**
	 *  Defines className for root node
	 */
	className: string,
	/**
	 *  Defines Button properties
	 */
	buttonProps: object,
}

export default StorelocatorLink
